import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

const state = {
  messagesAnalysed: [],
};

const getters = {
  messagesAnalysed: (state) => state.messagesAnalysed,
};

const actions = {
  async getMessagesAnalysed({ commit }, { globalOrganisationID, params }) {
    const filterParams = new URLSearchParams(params);

    const res = await $http.get(
      `${getApiClientUrl()}/v3/pt/history/globalOrganisationID/${globalOrganisationID}/stats/messages?${filterParams.toString()}`,
    );

    commit("setMessagesAnalysed", res.data.data);
  },
};

const mutations = {
  setMessagesAnalysed: (state, data) => (state.messagesAnalysed = data),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
